import React from 'react';
import { useTranslation } from 'react-i18next';

const SortDropdown = ({ sortBy, setSortBy }) => {
  const { t } = useTranslation();

  const sortOptions = [
    {
      value: 'newest',
      label: t('SearchJob.Newest First') || 'Newest First',
    },
    {
      value: 'oldest',
      label: t('SearchJob.Oldest First') || 'Oldest First',
    },
    {
      value: 'expiring-soon',
      label: t('SearchJob.Expiring Soon') || 'Expiring Soon',
    },
    {
      value: 'relevance',
      label: t('SearchJob.Most Relevant') || 'Most Relevant',
    },
  ];

  return (
    <div className="job-sort-dropdown">
      <select
        value={sortBy}
        onChange={(e) => setSortBy(e.target.value)}
        aria-label={t('SearchJob.Sort jobs') || 'Sort jobs by'}
        title={t('SearchJob.Sort jobs') || 'Sort jobs by'}
      >
        {sortOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SortDropdown;
